import { render, staticRenderFns } from "./ChartFooterV2.vue?vue&type=template&id=b4b7a466&scoped=true"
import script from "./ChartFooterV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartFooterV2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChartFooterV2.vue?vue&type=style&index=0&id=b4b7a466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b7a466",
  null
  
)

export default component.exports